export const SUPPORTED_LOCALES = ['en', 'de', 'es', 'cs'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export function localeFromUrl(url: string): SupportedLocale {
  return normalizeLocale(/^\/([^/?#]+)/u.exec(url)?.[1] ?? null);
}

export function normalizeLocale(value: null | string): SupportedLocale {
  return SUPPORTED_LOCALES.find((locale) => locale === value) ?? DEFAULT_LOCALE;
}

export function stripLocalePrefix(url: string): string {
  return url.replace(/^\/(en|de|es|cs)(?=\/|$|[?#])/u, '') || '/';
}
